import Model from './Model';
import QuotePosition from './QuotePosition';

export default class Quote extends Model {
  resource() {
    return 'quotes';
  }

  quotePositions() {
    return this.hasMany(QuotePosition);
  }
}
